import React, { useState, useEffect } from 'react';
import ChipInput from 'material-ui-chip-input';
import { useHistory } from 'react-router-dom';
import CloseIcon from 'style/imgs/icons/close-chip.svg';
import SendIcon from 'style/imgs/icons/send-chip.svg';
import { logEvent } from 'services/amplitude';
import { shareAnetaPacks as shareAnetaPacksAction } from 'actions/aneta-pack';
import newAnetapackFrom from 'components/email-templates/newAnetapackFrom';
import { sendNotification as sendNotificationAction } from 'actions/send-grid-notifications';
import Logo from 'components/common/logo';
import RightImage from 'style/imgs/congratulation.svg';
import RadiusInput from 'components/common/formElements/radiusInput';
import Avatar from '@material-ui/core/Avatar';
import buttons from 'style/buttons.module.scss';
import { IRootState } from 'store';
import { IShareAnetaPackData, IScholars } from 'types';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import Logger from 'components/common/helpers/devConsoleLog';
import { Chip } from '@material-ui/core';
import styles from './index.module.scss';

const mapStateToProps = (state: IRootState) => ({
  user: state.users,
  scholars: state.scholars,
  activeScholarId: state.users.userData?.activeScholarId,
  anetapackErrors: state.anetaPack.errors,
});
interface IProps extends ReturnType<typeof mapStateToProps> {
  shareAnetaPacks: (data: IShareAnetaPackData) => void;
  sendNotification: (emails: string[], html: string) => void;
}

const Congratulations: React.FC<IProps> = ({
  scholars,
  user,
  shareAnetaPacks,
  activeScholarId,
  anetapackErrors,
  sendNotification,
}) => {
  const [inputTags, setInputTags] = useState<string[]>([]);
  const [toastMsg, setToastMsg] = useState(false);
  const history = useHistory();
  const [kid, setKid] = useState<IScholars>();

  useEffect(() => {
    const activeKid = scholars.units?.find((u) => u.id === activeScholarId);
    if (activeKid) {
      setKid(activeKid);
    }
  }, [scholars, activeScholarId]);

  const handleToast = () => {
    setToastMsg(true);
    const timer = setTimeout(() => {
      setToastMsg(false);
    }, 15000);
    return () => {
      clearTimeout(timer);
    };
  };

  const handleSubmit = async () => {
    if (!activeScholarId) {
      Logger(
        'handleSubmit failed, no active scholars. activeScholarId is:',
        activeScholarId
      );
      return;
    }
    const emailsLowercased = inputTags?.map((t) => t?.toLowerCase());
    const requestData: IShareAnetaPackData = {
      unitId: activeScholarId,
      startTime: moment().startOf('week').format('YYYY-MM-DD 00:00'),
      emails: emailsLowercased,
    };
    await shareAnetaPacks(requestData);
    handleToast();
    if (user.userData) {
      sendNotification(inputTags, newAnetapackFrom(user.userData?.email));
    }
    logEvent('ShareAnetapack');
  };

  const handleAddChip = (chip: string) => {
    setInputTags([...inputTags, chip.trim()]);
  };

  const handleDeleteChip = (chip: string) => {
    setInputTags(_.without(inputTags, chip));
  };
  const useStyles = makeStyles(() => ({
    root: {
      borderRadius: '28px',
      boxShadow: 'none',
      boxSizing: 'border-box',
      [`& label`]: {
        background: '#fff',
        paddingRight: '20px',
      },
    },
  }));

  const classes = useStyles();

  return (
    <>
      <div className={styles.main}>
        <div className={styles.main__content}>
          <div className={styles.content__left}>
            <div className={styles.logo}>
              <Logo />
            </div>
            <div>
              <h1 className={`${styles.content__title} deep-gray-heading`}>
                {user.userData?.type === 'parent'
                  ? `Congratulations! ${kid?.name} is all set up.`
                  : `Congratulations! ${kid?.name} is Built`}
              </h1>
              {user.userData?.type === 'parent' && (
                <h2 className="deep-gray-heading">
                  Gift your work to family and friends
                </h2>
              )}
              {user.userData?.type === 'parent' && (
                <p className={styles.content__text}>
                  You have just created an Anetapack! Like a well-stocked
                  backpack, it will bring joy and learning to others. Share{' '}
                  {kid?.name}&apos;s Anetapack with parent&apos;s of their peers
                  and win major brownie points.
                </p>
              )}
              {user.userData?.type === 'teacher' && (
                <p className={styles.content__text}>
                  You have just created an Anetapack that will bring joy and
                  learning to others. Share this Anetapack and Empower your
                  student’s families with Digital organization.
                </p>
              )}
              <div className={styles.packDescription}>
                {user.userData?.type === 'parent' && (
                  <>
                    <Avatar
                      style={{ width: 56, height: 56 }}
                      src={kid?.avatar || ''}
                      alt={kid?.name}
                    />
                    <p>{kid?.name}&apos;s Anetapack </p>
                  </>
                )}
              </div>
              <div className={styles.userAction}>
                <RadiusInput
                  variant="outlined"
                  type="text"
                  label={user?.userData?.email}
                  name="email"
                  disabled
                />
                <ChipInput
                  variant="outlined"
                  label="Recipients' emails"
                  value={inputTags}
                  onAdd={(chip) => handleAddChip(chip)}
                  onDelete={(chip) => handleDeleteChip(chip)}
                  className={`${classes.root} ${styles.emailInput}`}
                  disableUnderline
                  chipRenderer={(
                    {
                      value,
                      isDisabled,
                      isReadOnly,
                      handleClick,
                      handleDelete,
                    },
                    key
                  ) => (
                    <Chip
                      key={key}
                      style={{
                        pointerEvents:
                          isDisabled || isReadOnly ? 'none' : undefined,
                        background:
                          'linear-gradient(360deg, #f5781e29 0%, #ffa7482e 100%)',
                        borderRadius: '15px',
                        display: 'grid',
                        gridTemplateColumns: '20px 1fr 20px',
                        alignItems: 'center',
                        color: ' #5F5577',
                        fontFamily: 'Proxima Nova Rg',
                        marginRight: '10px',
                      }}
                      onClick={handleClick}
                      onDelete={handleDelete}
                      label={value}
                      deleteIcon={
                        <div>
                          <img src={CloseIcon} alt="" />
                        </div>
                      }
                      avatar={
                        <div>
                          <img src={SendIcon} alt="" />
                        </div>
                      }
                    />
                  )}
                />
                {user.userData?.type === 'parent' ? (
                  <div className={styles.buttonsBlock}>
                    <button
                      type="submit"
                      className={`${buttons.buttomPrimary} ${styles.buttonWidth}`}
                      disabled={_.isEmpty(inputTags)}
                      onClick={() => {
                        handleSubmit();
                        handleToast();
                      }}
                    >
                      Send
                    </button>
                    <div className={styles.parentButtonsBlock}>
                      <button
                        type="submit"
                        className={`${buttons.buttonOrange} ${styles.orangeWidth}`}
                        onClick={() =>
                          history.push({
                            pathname: '/onboarding/profile',
                            state: { mode: 'create' },
                          })
                        }
                      >
                        Create another profile
                      </button>
                      <button
                        type="submit"
                        className={`${buttons.buttonOrange} ${styles.orangeWidth}`}
                        onClick={() => history.push('/map')}
                      >
                        Launch Scholar view
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className={styles.buttonsBlock}>
                    <div className={styles.buttonGroupTeacher}>
                      <button
                        type="submit"
                        className={`${buttons.buttomPrimary} ${styles.buttonSend}`}
                        disabled={_.isEmpty(inputTags)}
                        onClick={() => {
                          handleSubmit();
                          handleToast();
                        }}
                      >
                        Send
                      </button>
                      <button
                        type="submit"
                        className={`${buttons.buttonCancelOutlineRadius}`}
                        onClick={() => history.push('/dashboard/scholars')}
                      >
                        Go to Dashboard
                      </button>
                    </div>
                    <button
                      type="submit"
                      className={`${buttons.buttonOrange} ${styles.orangeBig}`}
                      onClick={() =>
                        history.push({
                          pathname: '/onboarding/profile',
                          state: { mode: 'create' },
                        })
                      }
                    >
                      Create another Anetapack
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className={styles.content__right}>
            <img src={RightImage} alt="img" />
          </div>
        </div>
      </div>
      {toastMsg && (
        <div className={styles.toastWrapper}>
          <div
            className={`${styles.toastBar} ${
              !_.isEmpty(anetapackErrors) && 'error-message'
            }`}
          >
            {!_.isEmpty(anetapackErrors)
              ? anetapackErrors[0][0].toUpperCase() +
                anetapackErrors[0].slice(1)
              : 'Your Anetapack was successfully shared'}
          </div>
        </div>
      )}
    </>
  );
};
export default connect(mapStateToProps, {
  shareAnetaPacks: shareAnetaPacksAction,
  sendNotification: sendNotificationAction,
})(Congratulations);
